import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/LoginPage.css";

const ResetPasswordSentPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  return (
    <div className="touch-wrapper" dir="rtl">
      <div className="touch-left">
        <div className="touch-logo-wrapper">
          <img
            src="/images/touch-prop-logo.png"
            alt="Touch Prop Logo"
            className="touch-logo"
          />
        </div>

        <div className="touch-reset-done-container">
          <div className="touch-reset-done-card">
            <h1 className="touch-reset-done-title">
              ایمیل بازیابی ارسال شد
            </h1>
            {email && (
              <p className="touch-reset-done-email">
                ایمیل: <span>{email}</span>
              </p>
            )}
            <p className="touch-reset-done-text">
              اگر ایمیل را دریافت نکردی، پوشه Spam را هم چک کن. در صورت نیاز می‌توانی دوباره درخواست ارسال بدهی.
            </p>

            <button
              type="button"
              className="touch-primary-btn touch-reset-done-btn"
              onClick={() => navigate("/login")}
            >
              بازگشت به ورود
            </button>
          </div>
        </div>
      </div>

      <div className="touch-right">
        <img
          src="/images/fingerprint-pattern.png"
          alt="Fingerprint"
          className="touch-fingerprint"
        />
        <div className="touch-right-overlay">
          <div className="touch-hero-text">
            <h2 className="touch-hero-title">تاچ پراپ ، لمس ثروت بی کران</h2>
            <p className="touch-hero-body">
              مسیر معامله‌گری هوشمند از همین‌جا شروع می‌شه
            </p>
            <div className="touch-dots">
              <span className="touch-dot touch-dot-active" />
              <span className="touch-dot" />
              <span className="touch-dot" />
              <span className="touch-dot" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordSentPage;
